module.exports = __webpack_public_path__ + "img/w3_paste_light.3d85097a.png";